enum SubOperationsEnum {
    Default = 0
}

/* increment the enum number */

enum Patient {
    AllVitals = 5,
    LoadPatientAndRedirect = 6,
    LoadPatientWithoutRedirecting = 7,
    LoadPatientSummary = 8,
    SetActivePatient = 9
}

enum Calendar {
    SearchAppointments_ModificationReload = 30,
    SearchAppointments_GeneralReload,
    LoadRuleset
}

enum Recalls {
    SaveFromView = 35,
    SaveFromGrid,
    SaveFromPopup
}

enum Documents {
    CreateNoteFromPopup = 40,
    CreateNoteFromForm,
    ApproveFromGrid,
    ApproveFromDocument,
    DisplayDocumentView,
    DisplayDocumentAnnotationView
}

enum Portfolio {
    LoadPatienrConsultationRequest = 50,
    LoadPatientConsultationRequest_ForFax = 50,
    LoadPatientRequest,
    DeleteRequest,
    GenerateConsultationRequestSigned_ForFax,
    GenerateConsultationRequestSigned_ForPrint,
    GenerateConsultationRequest_ForFax,
    GenerateConsultationRequest_ForPrint,
    FaxConsultationRequest,
    APSSGenerateMedicalNotePDF,
    GenerateLabRequest_ForIFrameReRender,
    GenerateLabRequest_ForPrint,
    APSSUploadAttachement,
    APSSUploadAttachementActionRequired
}

enum Labs {
    LabEncounterFile = 60,
    LabEncounterFileFromPatientFile,
    LabEncounterHold,
    LabEncounterHoldFromPatientFile,
    DefaultGetInboxCallbkack,
    OpenFirstLabGetInboxCallback,
    GetLab_Default,
    GetLab_FromPortalSyncPopupInInbox
}

enum PrivateBill {
    LoadInfoFromHistory = 80,
    LoadInfoFromHistorySideBar,
    LoadInfoFromNote,
    LoadInfoFromReusing,
    LoadInfoFromEdit,
    SaveWithPortalSyncWorkFlow,
    Save,
    LoadInfoFromNote_ForPrint,
    LoadListForReuse,
    LoadListForEncounter
}

enum MedicalNote {
    LoadEncounterForEdit = 100,
    LoadEncounterForView,
    ForSummaryRefresh,
    ForGrowthChart,
    CheckStatus_SaveNote,
    CheckStatus_SaveMedicalItem,
    LoadEncounterForEditAndRedirectToPatientTab,
    DeleteLabRequest,
    FaxConsultationRequest,
    GeneratePrivateBillForPrint,
    GeneratePrivateBillForReuse,
    LoadSummaryAndKeepDisplayedEncounters,
    LoadSummaryAndReloadDisplayedEncounters
}
enum Billing {
    LoadPatientTransaction = 125
}

enum PatientHistory {
    LoadMessageNotes = 130,
    LoadTaskNotes
}

enum MedicalItems {
    SaveMedicalItems = 140,
    SaveMedicalItemsPlus,
    SaveInNewEncounter
}

enum PortalLinkedItemStatus {
    PrivateBill = 150,
    Document,
    Results,
    MedicalSummary,
    Communication,
    Portfolio,
    Requests,
    MedicalNoteForm
}

enum Administration {
    ServiceCombo_ReloadFromGrid = 160,
    SaveProfileImage,
    LoadPdfTags,
    RefreshEmployees,
    RefreshServicesAndLookups,
    Users_RefreshEmployees
}

enum Scheduling {
    LoadRuleset = 170
}

enum Login {
    LogoutWithSessionCheck,
    LogoutToHomeScreen
}

enum Profile {
    LoadForAdd,
    LoadForEdit,
    SaveProfileImage
}

enum AttachedCommunications {
    Documents,
    Labs,
    Encounter
}

enum PortalRevokeItem {
    FromMedicalNote = 180
}

enum Relative {
    LoadAndOpenFile,
    OpenFile
}

enum AIScribe {
    SaveAIScribeConsultationNote = 200,
    SaveAIScribeConsultationNoteOnEditMode
}

export { Administration, AIScribe, AttachedCommunications, Billing, Calendar, Documents, Labs, Login, MedicalItems, MedicalNote, Patient, PatientHistory, PortalLinkedItemStatus, PortalRevokeItem, Portfolio, PrivateBill, Profile, Recalls, Relative, Scheduling, SubOperationsEnum };
